module.exports = __webpack_public_path__ + "img/img2.318b405e.png";